/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PreanalysisQuestionModelDto } from '../../models/preanalysis-question-model-dto';

export interface PreanalysisControllerGetQuestions$Params {
  uuid: string;
}

export function preanalysisControllerGetQuestions(http: HttpClient, rootUrl: string, params: PreanalysisControllerGetQuestions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PreanalysisQuestionModelDto>>> {
  const rb = new RequestBuilder(rootUrl, preanalysisControllerGetQuestions.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PreanalysisQuestionModelDto>>;
    })
  );
}

preanalysisControllerGetQuestions.PATH = '/match-videos/{uuid}/questions';
